import { ContentLoadingComponent } from './content-loading.component'
import { CommonModule } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { LottieCacheModule, LottieModule } from 'ngx-lottie'

@NgModule({
  declarations: [ContentLoadingComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    LottieCacheModule,
    LottieModule,
  ],
  exports: [ContentLoadingComponent],
})
export class ContentLoadingModule {}
